import { shortProgrammes } from '../../data/mockData';
import SectionHeading from '../ui/SectionHeading';

export default function ShortProgrammes() {
  return (
    <section className="bg-white">
      <div className="section-shell">
        <SectionHeading
          eyebrow="Four months"
          title="Vendor certification short programmes"
          description="Focused Microsoft and CompTIA tracks for learners who already have a base and want a specific certification on the CV."
        />

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {shortProgrammes.map((programme) => (
            <article
              key={programme.id}
              className="card-surface card-surface-hover flex flex-col p-6"
            >
              <div className="flex items-center justify-between gap-3">
                <span
                  className={`rounded-full px-3 py-1 text-xs font-bold ${programme.tint}`}
                >
                  {programme.vendor}
                </span>
                <span className="text-xs font-semibold text-brand-900/45">
                  {programme.durationMonths} months
                </span>
              </div>

              <h3 className="mt-4 text-base font-bold leading-snug text-brand-950">
                {programme.title}
                {programme.code && (
                  <span className="ml-2 text-sm font-semibold text-brand-600">
                    {programme.code}
                  </span>
                )}
              </h3>

              <p className="mt-2.5 flex-1 text-sm leading-relaxed text-brand-900/60">
                {programme.summary}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
